import React from "react";
import { Link, } from 'react-router-dom';

const cta = () => {
    return (


        <section className="cta section-padding parallax" data-bg-image="assets/images/cta-bg.jpg">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <h2>اولویت اول ما <span> رضایت مشتری</span> است</h2>
                        <Link to="consult" className="theme-btn-s5">دریافت مشاوره</Link>
                    </div>
                </div>
            </div>
        </section>


    );
};

export default cta; 